<template>
  <div>
    <free-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj="titleObj"
    >
    </free-header>

    <free-program></free-program>

    <free-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    >
    </free-footer>
  </div>
</template>
<script>
import FreeHeader from "@/components/pc/Header";
import FreeProgram from "@/components/pc/FreeProgram";
import FreeFooter from "@/components/pc/Footer";
export default {
  name: "freeMarket",
  data() {
    return {
      marketType: "",
      actIndex: 2, //页码
      imgList: [], //轮播图
      logo: "", //logo
      bottomInfo: {}, //底部联系我们
      productType: [], //产品类别
      bottom: {}, //底部信息
      bottomNews: [],
      topStyle: "", //页样式
      titleObj: {},
    };
  },
  components: {
    FreeHeader,
    FreeProgram,
    FreeFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();

    this.titleObj = {
      title: "免单节营销解决方案",
      desc: "狂欢免单，创造属于自己的城市营销解决方案",
    };
    this.topStyle =
      "background-image:url('" +
      require("../../static/images/product/free_bg.png") +
      "')";
  },
  watch: {},
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_freeMarket");
      } else {
        this.$router.push("/freeMarket");
      }
    },
    getPageData() {
      this.$http.post("home/index/aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;

        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.type;
        this.bottomNews = res.data.b_news;
      });
    },
  },
};
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/pc/FreeMarket.vue